import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  min-height: 100vh;
  min-width: 100vw;
  background: hsl(0, 0%, 60%, 0.7);
  display: ${({ isModalOpen }) => !isModalOpen && 'none'};
  text-decoration: none;
`;

const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: white;
  width: 90vw;
  height: 60vh;
  padding: 1rem;
  border-radius: 1rem;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Cancel = styled.button`
  color: hsl(27, 86%, 78%);
  font-weight: bold;
`;
const Validate = styled.button`
  color: white;
  background: hsl(0, 79%, 72%);
  font-weight: bold;
  padding: 0.5rem 1rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
`;

export { Modal, Buttons, Cancel, Validate };

export default Container;
